import * as React from 'react';

import { cn } from '@/lib/utils';

interface SnailGlyphProps extends React.SVGProps<SVGSVGElement> {
    size?: number;
    /** Rotates the shell continuously — used for loading states. */
    spinning?: boolean;
}

/**
 * The SnappyTrade shell spiral — the mascot reduced to a single stroke.
 * Doubles as the in-app brand glyph and the loading spinner.
 */
export function SnailGlyph({
    size = 20,
    spinning = false,
    className,
    ...props
}: SnailGlyphProps) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            // As a spinner it must announce itself; as the brand glyph it's decorative.
            aria-hidden={spinning ? undefined : 'true'}
            role={spinning ? 'status' : undefined}
            aria-label={spinning ? 'Loading' : undefined}
            className={cn(
                spinning && 'motion-safe:animate-spin',
                className,
            )}
            {...props}
        >
            <path
                d="M21 12 A9 9 0 0 1 3 12 A7.5 7.5 0 0 1 18 12 A6 6 0 0 1 6 12 A4.5 4.5 0 0 1 15 12 A3 3 0 0 1 9 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
}
